import { useState } from "react";
import type { UpdateMediaSettingsPayload } from "@circle-react/api/mediaSettingsApi";
import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { Loader } from "@circle-react-uikit/Loader";
import { ModalBody } from "./ModalBody";
import { ModalFooter } from "./ModalFooter";
import { ModalHeader } from "./ModalHeader";
import type { ModalTab } from "./types";

interface ModalProps {
  initialTab?: ModalTab;
  isOpen: boolean;
  isSubmitting: boolean;
  mediaSettings?: MediaSetting;
  onClose: () => void;
  onSubmit: (data: UpdateMediaSettingsPayload) => void;
}

export const Modal = ({
  isOpen,
  isSubmitting,
  mediaSettings,
  onClose,
  onSubmit,
  initialTab,
}: ModalProps) => {
  const [selectedTab, setSelectedTab] = useState<ModalTab>(
    initialTab || "edit",
  );
  const isSubmitDisabled = isSubmitting || !mediaSettings;

  return (
    <FullScreenModal isOpen={isOpen} onClose={onClose} shouldShowCloseButton>
      <FullScreenModal.Header className="!pb-0 !pt-4 md:!py-5">
        <ModalHeader
          isSubmitDisabled={isSubmitDisabled}
          onClose={onClose}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </FullScreenModal.Header>
      <FullScreenModal.Body wrapperClassName="h-full">
        {mediaSettings ? (
          <ModalBody
            mediaSettings={mediaSettings}
            onSubmit={onSubmit}
            selectedTab={selectedTab}
            signedId={mediaSettings.blob_signed_id}
          />
        ) : (
          <Loader center />
        )}
      </FullScreenModal.Body>
      {selectedTab === "edit" && (
        <FullScreenModal.Footer className="md:hidden">
          <ModalFooter isSubmitDisabled={isSubmitDisabled} />
        </FullScreenModal.Footer>
      )}
    </FullScreenModal>
  );
};
